@if (componentType(); as cmp) {
    <ng-container *ngTemplateOutlet="widgetOutlet; context: { cmp }" />
}

<ng-template #widgetOutlet let-cmp="cmp">
    <ng-container *ngComponentOutlet="cmp; inputs: outletInputs()" />
</ng-template>
